function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\u2705-Project",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Moje-faktury---wszystko-op\\u0142acone",
  transform: "translate(-1497.000000, -866.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8",
  transform: "translate(1468.000000, 857.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Fill-1882",
  transform: "translate(26.000000, 9.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(-0.000142, 0.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Safespace",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}), /*#__PURE__*/React.createElement("g", {
  id: "pobierzPDF",
  transform: "translate(2.500000, 0.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.84,6.64 C14.84,6.64 14.84,6.64 14.84,6.58 C14.8174528,6.50648847 14.7800085,6.43840782 14.73,6.38 L14.73,6.38 L9.45,0.88 C9.45,0.88 9.45,0.88 9.45,0.88 C9.39410656,0.831768997 9.32965764,0.794456467 9.26,0.77 L2.86,0.77 C2.60042617,0.77 2.39,0.980426168 2.39,1.24 L2.39,16.8 C2.39,17.0595738 2.60042617,17.27 2.86,17.27 L14.38,17.27 C14.6395738,17.27 14.85,17.0595738 14.85,16.8 L14.85,6.7 C14.85,6.7 14.84,6.66 14.84,6.64 Z",
  id: "Path",
  fill: "#47A9A0",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.88,8.24 L12.88,8.24 L7.6,2.73 L7.6,2.73 C7.50461171,2.63428026 7.37513358,2.58033104 7.24,2.58 L1,2.58 C0.723857625,2.58 0.5,2.80385763 0.5,3.08 L0.5,16.56 L1.5,16.56 L1.5,3.56 L6.73,3.56 L6.73,8.56 C6.73,8.83614237 6.95385763,9.06 7.23,9.06 L12,9.06 L12,9.63 C12,9.90614237 12.2238576,10.13 12.5,10.13 C12.7739085,10.1246799 12.9946799,9.90390845 13,9.63 L13,8.58 C13.0057027,8.45537888 12.962663,8.33343324 12.88,8.24 Z M7.73,8.08 L7.73,4.32 L11.34,8.08 L7.73,8.08 Z",
  id: "Shape",
  fill: "#5B5B5B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.5,15.37 L1.5,18.18 L9.88,18.18 C10.1539085,18.1853201 10.3746799,18.4060915 10.38,18.68 C10.38,18.9561424 10.1561424,19.18 9.88,19.18 L1,19.18 C0.723857625,19.18 0.5,18.9561424 0.5,18.68 L0.5,15.37 L1.5,15.37 Z",
  id: "Path",
  fill: "#5B5B5B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.1,15.49 C14.9987032,15.404499 14.8670872,15.3636866 14.7351877,15.3768766 C14.6032881,15.3900665 14.48236,15.4561333 14.4,15.56 L13,17.24 L13,14.58 C13,14.3038576 12.7761424,14.08 12.5,14.08 C12.2238576,14.08 12,14.3038576 12,14.58 L12,17.24 L10.61,15.56 C10.4282925,15.3788364 10.1389469,15.3646225 9.94035805,15.5271043 C9.74176922,15.689586 9.6984055,15.9760167 9.84,16.19 L12.13,19 C12.2279873,19.1133971 12.3701353,19.1790039 12.52,19.1800003 C12.6672813,19.1801582 12.8068221,19.11406 12.9,19 L15.17,16.24 C15.2727254,16.1369121 15.3243117,15.9934956 15.3107874,15.8485932 C15.2972632,15.7036907 15.220028,15.5722976 15.1,15.49 Z",
  id: "Path",
  fill: "#5B5B5B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.52,13.35 C12.2438576,13.35 12.02,13.1261424 12.02,12.85 L12.02,11.27 C12.02,10.9938576 12.2438576,10.77 12.52,10.77 C12.7939085,10.7753201 13.0146799,10.9960915 13.02,11.27 L13.02,12.85 C13.02,12.9826082 12.9673216,13.1097852 12.8735534,13.2035534 C12.7797852,13.2973216 12.6526082,13.35 12.52,13.35 Z",
  id: "Path",
  fill: "#5B5B5B"
})))))));

var SvgDownloadPdf = function SvgDownloadPdf(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "20px",
    viewBox: "0 0 15 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownloadPdf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DownloadPDF.047d5ee7.svg";
export { ForwardRef as ReactComponent };